import { createFileRoute } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

export const Route = createFileRoute('/(auth)/not-verified/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-gray-900">
      <section className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-lg  xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              <FormattedMessage id="auth.notVerified.title" />
            </h1>
            <p className="text-sm font-light text-gray-500 dark:text-gray-400">
              <FormattedMessage id="auth.notVerified.subtitle" />
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
